import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { getUuid } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import { getEmbedSourceAppBestURL } from 'automation-ui-source-apps/utils/sourceAppLinkUtils';
import { getSourceAppNameInPhraseMessage } from 'automation-ui-source-apps/utils/sourceAppMessageUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ReadOnlySourceAppBanner({
  flow,
  sourceApp
}) {
  const getContentMessage = () => {
    if (sourceApp === SourceApps.DIRECT_API) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.readOnlyBanner.managedByInternalApi.content"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.common.readOnlyBanner.managedByExternalApp.content"
    });
  };
  const getSourceAppLink = () => {
    if (!sourceApp) {
      return null;
    }
    const sourceAppMessage = getSourceAppNameInPhraseMessage(sourceApp);
    const buttonHref = getEmbedSourceAppBestURL(sourceApp, getUuid(flow));
    if (sourceAppMessage && buttonHref) {
      return /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [getContentMessage(), /*#__PURE__*/_jsx(UIButton, {
          href: buttonHref,
          external: true,
          size: "extra-small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "list.backToSourceApp_jsx",
            options: {
              sourceApp: sourceAppMessage
            }
          })
        })]
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsx(UIAlert, {
    "data-test-id": "alert-read-only-banner",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.common.readOnlyBanner.managedByExternalApp.title"
    }),
    className: "m-bottom-4",
    children: getSourceAppLink() || getContentMessage()
  });
}
export default ReadOnlySourceAppBanner;